export default "__VITE_ASSET__b6360f5a__"